<template>
  <tbody v-if="vehicle">
    <tr>
      <td>
        <v-checkbox
          class="my-0"
          v-model="vehicle.selected"
          style="float: left"
        />
      </td>
      <td>{{ vehicle.regNo }}</td>
      <td>
        {{ vehicle.bodyType }}
      </td>
      <td>
        {{ vehicle.truckTypeStr }}
      </td>
      <td>
        {{ vehicle.axel == 1 ? 'S-Axel' : vehicle.axel == 2 ? 'M-Axel' : '' }}
      </td>
      <td>{{ vehicle.capacity ? vehicle.capacity + ' T' : '' }}</td>
      <td>{{ vehicle.kms }}</td>
      <td>{{ vehicle.year }}</td>
      <td>{{ vehicle.vendorName }}</td>
      <td>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="body-2">
            <v-row v-if="vehicle.driver_id">
              <v-col cols="12" sm="12" md="12" lg="12">
                <a style="float: left" :href="'/driver/' + vehicle.driver_id"
                  >{{ vehicle.driverCC }} {{ vehicle.driverPhone }}
                  {{ vehicle.driverName }}</a
                >
                <z-confirm-button
                  style="height: 10px"
                  color="orange"
                  x-small
                  fab
                  text
                  v-if="vehicle.showDriverUnassign"
                  :loading="loading"
                  :message="$i18n.t('Do you want to unassign driver ?')"
                  @click="unassignDriver(vehicle._id)"
                >
                  <v-icon>mdi-close</v-icon>
                </z-confirm-button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="vehicle.showDriverAssign">
          <v-col cols="12" sm="11" md="11" lg="11">
            <v-btn
              v-if="!vehicle._showAssign"
              @click="vehicle._showAssign = true"
              x-small
              color="blue"
              >{{ $i18n.t("Assign Driver") }}</v-btn
            >

            <z-driver-select
              idOnly
              v-if="vehicle._showAssign"
              v-model="vehicle.driverID"
            ></z-driver-select>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" v-if="vehicle.driverID">
            <v-btn
              v-if="vehicle.driverID"
              :loading="loading"
              @click="assignDriver(vehicle._id, vehicle.driverID)"
              x-small
              color="green"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </td>
      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Vehicle ?')"
          @click="deleteVehicle(vehicle._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="success"
          @click="select"
          v-if="showSelectBtn"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          v-if="!singlePage"
          :to="'/vehicle/' + vehicle._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          v-if="singlePage"
          @click="editVehicle"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
  <!-- <v-card-text class="py-0" v-if="vehicle">
    <v-row>
      <v-col cols="12" xs="11" sm="12" md="10" lg="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="5" lg="5" class="body-2">
            <v-row>
              <v-col cols="12" xs="13" sm="2" md="1" class="body-2"></v-col>

              <v-col cols="12" xs="3" sm="3" md="3" class="body-2"></v-col>

              <v-col cols="12" xs="3" sm="4" md="4" class="body-2">
                <b></b>
                <br />

                <br />&nbsp;
                <span style="text-transform:capitalize;">{{vehicle.color}}</span>
              </v-col>

              <v-col cols="12" xs="3" sm="3" md="4" class="body-2">
                <v-icon v-if="vehicle.seats">mdi-seat-passenger</v-icon>
                {{vehicle.seats ? vehicle.seats : ''}}
                <br v-if="vehicle.seats" />
                <v-icon v-if="vehicle.kms">mdi-road-variant</v-icon>
                {{vehicle.kms ? vehicle.kms : ''}}
                <br v-if="vehicle.kms" />
                <v-icon v-if="vehicle.driveSide">mdi-seat-recline-extra</v-icon>
                {{vehicle.driveSide == 1 ? 'Right Drive' : (vehicle.driveSide == 2 ? 'Left Drive' : '')}}
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="3" lg="4" class="body-2"></v-col>

          <v-col cols="12" xs="12" sm="3" md="2" lg="2" class="body-2">
            <a></a>
            <br />
            <v-chip
              v-if="vehicle.compliant == 1"
              small
              color="green"
              text-color="white"
            >Compliance Done</v-chip>
            <v-chip v-if="vehicle.compliant == 2" small color="red" text-color="white">Not Compliant</v-chip>
            <v-chip small v-if="vehicle.compliant == 3">Compliance Due</v-chip>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="2" lg="1" class="body-2">
  {{vehicle.country}}-->
  <!-- <br /> -->
  <!-- <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" style="background-color:#35964a" x-small>
                  <h3>
                    <span>{{ vehicle.zoneName ? vehicle.zoneName : 'Assign Zone'}}</span>
                    <v-icon>mdi-menu-down</v-icon>
                  </h3>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="z in zoneList" v-bind:key="z._id">
                  <v-btn
                    class="float-right"
                    text
                    :loading="loading"
                    @click="changeZone(vehicle, z._id)"
                  >{{ z.name }}</v-btn>
                </v-list-item>
              </v-list>
  </v-menu>-->
  <!-- </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="1" sm="12" md="2" lg="2" class="text-center pl-0"></v-col>
    </v-row>
  </v-card-text>-->
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "VehicleRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
    refresh: {
      default: null,
    },
    payload: {
      default: null,
    },
    showSelectBtn: {
      default: false,
    },
    singlePage: {
      default: false,
    },
  },
})
export default class VehicleRow extends Vue {
  vehicle = null;
  limit = 2;
  loading = false;

  select(data) {
    this.$emit("select", this.vehicle);
  }

  editVehicle() {
    this.$emit("editVehicle", this.vehicle._id);
  }

  async deleteVehicle(vehicle_id) {
    this.loading = true;
    try {
      await doGet("/api/vehicle/delete/" + vehicle_id);
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    this.loading = false;
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.vehicle = this.value;
      // this.zoneList = this.payload.zones;
    }
  }

  async assignDriver(vehicle_id, driver_id) {
    this.loading = true;
    try {
      await doGet(
        "/api/vehicle/" + vehicle_id + "/driver/" + driver_id + "/assign"
      );
      common.showMessage("Assigned Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
      await this.refresh(1);
    }
    this.loading = false;
  }

  async unassignDriver(vehicle_id) {
    this.loading = true;
    try {
      await doGet("/api/vehicle/" + vehicle_id + "/driver/unassign");
      common.showMessage("Unassigned Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
      await this.refresh(1);
    }
    this.loading = false;
  }

  @Watch("value")
  onValueChange(val) {
    this.vehicle = val;
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.vehicle.selected = val;
  }
}
</script>
